/**
 * Retry delay for a failing poll (spec 037): 2 s, 4 s, 8 s, then 15 s for
 * every further failure. `attempt` is the consecutive-failure count (1-based);
 * anything below 1 is treated as the first failure.
 */
export function nextDelay(attempt: number): number {
  if (attempt <= 1) return 2000
  if (attempt === 2) return 4000
  if (attempt === 3) return 8000
  return 15000
}
